import Swal from 'sweetalert2';

export default function ErrorPopup(message?: string, visibilityTime: number = 3000) {
    let timerInterval: number | undefined;
    return Swal.fire({
        position: 'top',
        html: `
            <div class="flex items-center justify-center">
                <p class="m-0 text-base">${message || "Error! Something went wrong..."}</p>
            </div>
        `,
        timer: visibilityTime,
        timerProgressBar: true,
        showConfirmButton: false,
        backdrop: false,
        willClose: () => {
            clearInterval(timerInterval)
        }
    })
}
